import { SUBURBAN_COMBINE_SEARCH } from 'shared/map-search/constants/config';
import { IApplicationState } from 'shared/map-search/types/redux';

import { isExperimentActive, selectExperiments } from './experiments';

export const selectIsSuburbanCombineSearchEnabled = (state: IApplicationState): boolean => {
  const experiments = selectExperiments(state);

  return isExperimentActive(experiments, SUBURBAN_COMBINE_SEARCH, 'B');
};
